<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline"
    :class="[width, height]"
    viewBox="0 0 78.207 62.112"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.844"
        y1="-0.184"
        x2="0.387"
        y2="0.646"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
    </defs>
    <g id="Group_252" data-name="Group 252" transform="translate(0 -52.685)">
      <path
        id="Path_877"
        data-name="Path 877"
        d="M76.66,89.645c-3.415-8.69-13.935-13.9-22.844-10.452-10.17,3.936-6.8,20.113-16.036,23.384-4.99,1.767-12.367-4.834-17.409-5.846C11.081,94.866,2.67,101.421.6,110.5c-2.113,9.261,1.276,21.631,11.451,24.144,12.121,2.994,18.434-7.9,28.6-11.03,10.434-3.211,22.036,4.372,30.674-4.854,6.382-6.816,8.715-20.51,5.333-29.114Z"
        transform="translate(0 -21.548)"
        fill="url(#linear-gradient)"
      />
      <g id="Group_251" data-name="Group 251" transform="translate(8.372 52.685)">
        <path
          id="Path_878"
          data-name="Path 878"
          d="M123.513,118a10.925,10.925,0,0,0-21.144-3.859h-39.5a3.055,3.055,0,0,0-3.055,3.055v33.82a3.055,3.055,0,0,0,3.055,3.055h53.825a3.055,3.055,0,0,0,3.055-3.055V126.249A10.9,10.9,0,0,0,123.513,118Z"
          transform="translate(-59.048 -98.768)"
          fill="#383838"
          opacity="0.1"
          style="isolation: isolate"
        />
        <g id="Group_249" data-name="Group 249" transform="translate(0 3.726)">
          <g id="Group_241" data-name="Group 241" transform="translate(0.764 7.828)">
            <path
              id="Path_879"
              data-name="Path 879"
              d="M116.691,168.256H62.867a3.055,3.055,0,0,1-3.055-3.055v-33.82a3.055,3.055,0,0,1,3.055-3.055h53.825a3.055,3.055,0,0,1,3.055,3.055V165.2A3.055,3.055,0,0,1,116.691,168.256Z"
              transform="translate(-59.812 -128.326)"
              fill="#fff"
            />
            <path
              id="Path_880"
              data-name="Path 880"
              d="M90.71,221.957l29.037,22.305a3.055,3.055,0,0,1-3.055,3.055H62.867a3.055,3.055,0,0,1-3.055-3.055l29.037-22.305a1.527,1.527,0,0,1,1.861,0Z"
              transform="translate(-59.812 -207.387)"
              fill="#fff"
            />
            <path
              id="Path_881"
              data-name="Path 881"
              d="M88.849,153.686,59.812,131.381a3.055,3.055,0,0,1,3.055-3.055h53.825a3.055,3.055,0,0,1,3.055,3.055L90.71,153.686A1.528,1.528,0,0,1,88.849,153.686Z"
              transform="translate(-59.812 -128.326)"
              fill="#fff"
            />
          </g>
          <g id="Group_247" data-name="Group 247" transform="translate(23.558 38.782)">
            <path
              id="Path_882"
              data-name="Path 882"
              d="M339.485,335.882h-4.908a.764.764,0,0,1-.764-.764v-3.384a.764.764,0,0,1,.764-.764h4.908a.764.764,0,0,1,.764.764v3.384A.764.764,0,0,1,339.485,335.882Z"
              transform="translate(-314.754 -330.971)"
              fill="#f0324c"
            />
            <g id="Group_246" data-name="Group 246" transform="translate(0 0.271)">
              <g id="Group_243" data-name="Group 243" transform="translate(10.692)">
                <g id="Group_242" data-name="Group 242">
                  <path
                    id="Path_883"
                    data-name="Path 883"
                    d="M284.053,334.271H279.8a.764.764,0,1,1,0-1.527h4.251a.764.764,0,0,1,0,1.527Z"
                    transform="translate(-279.038 -332.743)"
                    fill="#2f3042"
                  />
                </g>
              </g>
              <g id="Group_245" data-name="Group 245" transform="translate(0 3.113)">
                <g id="Group_244" data-name="Group 244">
                  <path
                    id="Path_884"
                    data-name="Path 884"
                    d="M224.746,354.652H209.8a.764.764,0,0,1,0-1.527h14.944a.764.764,0,0,1,0,1.527Z"
                    transform="translate(-209.038 -353.125)"
                    fill="#2f3042"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_248" data-name="Group 248">
            <circle
              id="Ellipse_260"
              data-name="Ellipse 260"
              cx="10.923"
              cy="10.923"
              r="10.923"
              transform="translate(42.605 0.766)"
              fill="#f0324c"
            />
            <path
              id="Path_885"
              data-name="Path 885"
              d="M108.353,100.452a11.707,11.707,0,1,0-7.158-2.459L86.008,109.659a.764.764,0,0,1-.931,0L56.367,87.6a2.3,2.3,0,0,1,2.264-1.936H93.666a.764.764,0,0,0,0-1.527H58.631a3.823,3.823,0,0,0-3.819,3.819v33.82a3.823,3.823,0,0,0,3.819,3.819h53.825a3.823,3.823,0,0,0,3.819-3.819V101.6a.764.764,0,1,0-1.527,0v18.634l-20-15.36,7.781-5.977a11.611,11.611,0,0,0,5.821,1.559Zm-32.017,4.418-20,15.36V89.509Zm38.381,17.263a2.293,2.293,0,0,1-2.261,1.938H58.631a2.293,2.293,0,0,1-2.261-1.938l21.22-16.3,6.558,5.038a2.294,2.294,0,0,0,2.792,0l6.558-5.038ZM98.193,88.764a10.16,10.16,0,1,1,10.16,10.16A10.172,10.172,0,0,1,98.193,88.764Z"
              transform="translate(-54.812 -77.076)"
              fill="#2f3042"
            />
          </g>
          <path
            id="Path_886"
            data-name="Path 886"
            d="M373.773,123.32l1.559,3.725-1.559,3.725a.764.764,0,0,0,1,1l9.412-4.02a.764.764,0,0,0,0-1.4l-9.412-4.02A.764.764,0,0,0,373.773,123.32Z"
            transform="translate(-325.001 -115.358)"
            fill="#fff"
          />
        </g>
        <g id="Group_250" data-name="Group 250" transform="translate(15.286 0)">
          <path
            id="Path_887"
            data-name="Path 887"
            d="M318.548,57.113a2.214,2.214,0,1,1,1.566-.648A2.207,2.207,0,0,1,318.548,57.113Zm0-2.9a.687.687,0,1,0,.486.2A.686.686,0,0,0,318.548,54.212Z"
            transform="translate(-291.673 -52.685)"
            fill="#f0324c"
          />
          <path
            id="Path_888"
            data-name="Path 888"
            d="M206.258,434.757a2.214,2.214,0,1,1,1.566-.648,2.208,2.208,0,0,1-1.566.648Zm0-2.9a.687.687,0,1,0,.486.2A.685.685,0,0,0,206.258,431.856Z"
            transform="translate(-196.535 -372.645)"
            fill="#f0324c"
          />
          <path
            id="Path_889"
            data-name="Path 889"
            d="M274.446,78.026a.761.761,0,0,1-.54-.224L273,76.892l-.911.911a.764.764,0,0,1-1.08-1.08l1.451-1.451a.764.764,0,0,1,1.08,0l1.451,1.451a.764.764,0,0,1-.54,1.3Z"
            transform="translate(-253.077 -71.632)"
            fill="#f0324c"
          />
          <path
            id="Path_890"
            data-name="Path 890"
            d="M419.412,423.8a.761.761,0,0,1-.54-.224l-.911-.911-.911.911a.764.764,0,0,1-1.08-1.08l1.451-1.451a.764.764,0,0,1,1.08,0l1.451,1.451a.764.764,0,0,1-.54,1.3Z"
            transform="translate(-375.9 -364.591)"
            fill="#f0324c"
          />
          <path
            id="Path_891"
            data-name="Path 891"
            d="M158.55,428.551a.761.761,0,0,1-.54-.224l-.911-.911-.911.911a.764.764,0,0,1-1.08-1.08l1.451-1.451a.764.764,0,0,1,1.08,0l1.451,1.451a.764.764,0,0,1-.54,1.3Z"
            transform="translate(-154.884 -368.615)"
            fill="#f0324c"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-14'
    },
    height: {
      type: String,
      default: 'h-16'
    }
  }
}
</script>
